import { useAccount } from "@Light/components/page/account";
import { useContext } from "react";
import { EnrollmentContext } from "./flow/context";

export function useIsReEnrollment(): boolean {
  const account = useAccount();
  const enrollment = useContext(EnrollmentContext);

  if (!enrollment) {
    return false;
  }

  if (account.enrollment?.is_service_active) {
    return true;
  }

  const location = account.locations.length > 0 ? account.locations[0] : null;
  return Boolean(location?.final_service_date);
}
